module.exports = __webpack_public_path__ + "static/media/orange-in-german.cb5a6a0e.jpg";